"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require("material-ui/SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FireWing = function FireWing(props) {
	return _react2.default.createElement(
		_SvgIcon2.default,
		(0, _extends3.default)({ viewBox: "0 0 511.999 511.999", className: "custom-icon" }, props),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { d: "M192.835,1.681c-2.756-2.242-6.709-2.242-9.465,0c-24.681,20.076-24.63,57.646,0,77.681c2.756,2.242,6.709,2.242,9.465,0 c11.753-9.56,18.492-23.716,18.492-38.841C211.328,25.396,204.588,11.24,192.835,1.681z M188.103,63.08 c-10.886-12.907-11.047-32.019,0-45.116C198.992,30.874,199.146,49.986,188.103,63.08z" })
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { d: "M444.409,138.698c-2.756-2.242-6.709-2.242-9.465,0c-24.632,20.035-24.681,57.606,0,77.681 c2.756,2.242,6.709,2.242,9.465,0C469.137,196.267,468.994,158.695,444.409,138.698z M439.677,200.096 c-10.888-12.909-11.047-32.019,0-45.116C450.565,167.89,450.724,186.999,439.677,200.096z" })
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { d: "M72.663,170.144c-2.757-2.242-6.708-2.242-9.465,0c-18.82,15.306-18.781,43.961,0,59.234c2.757,2.242,6.708,2.242,9.465,0 C91.483,214.073,91.444,185.418,72.663,170.144z M67.931,212.53c-5.04-7.609-5.182-17.715,0-25.538 C72.971,194.601,73.112,204.707,67.931,212.53z" })
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { d: "M334.651,67.726c-2.758-2.242-6.709-2.242-9.465,0c-18.82,15.308-18.78,43.959,0,59.234c2.755,2.242,6.709,2.242,9.465,0 C353.471,111.656,353.433,83.001,334.651,67.726z M329.918,110.112c-5.06-7.64-5.161-17.746,0-25.538 C335.002,92.245,335.06,102.352,329.918,110.112z" })
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { d: "M437.634,263.127C425.055,226.167,404.081,191,376.983,161.43c-5.948-6.493-17.018-18.584-29.183-15.18 c-8.343,2.333-13.905,11.059-17.01,26.674c-0.681,3.427-1.66,6.595-2.836,9.564c-5.546-15.606-14.293-31.663-26.461-48.629 c-1.259-1.755-2.677-3.612-4.337-5.681c-5.291-6.592-22.822-31.348-26.264-73.148c-1.052-12.783-16.289-18.808-25.787-10.18 c-20.209,18.336-37.451,40.479-50.24,65.577c-1.88,3.691-0.413,8.207,3.278,10.088c3.688,1.877,8.206,0.412,10.087-3.277 c11.74-23.041,27.708-43.813,46.958-61.282c0.296-0.272,0.722-0.105,0.756,0.305c3.79,46.048,23.55,73.876,29.515,81.307 c13.833,17.235,28.214,42.613,32.893,66.29c1.305,6.611,10.034,8.27,13.67,2.594c5.186-8.087,10.929-17.788,13.478-30.606 c2.739-13.781,6.302-15.142,6.337-15.151c6.221-1.717,50.983,46.701,71.597,107.265c1.339,3.935,5.615,6.015,9.517,4.683 C436.872,271.309,438.969,267.049,437.634,263.127z" })
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { d: "M446.905,297.961c-0.782-4.069-4.72-6.731-8.781-5.951c-4.067,0.781-6.731,4.712-5.95,8.78 c12.329,64.199-3.235,121.74-54.075,160.275c48.683-61.48,23.011-153.986-29.516-211.306c-4.346-4.742-13.39-14.617-23.528-11.773 c-10.343,2.892-12.625,15.857-14.299,22.75c-15.333-37.16-36.134-41.174-40.021-88.399c-0.911-11.063-14.099-16.271-22.318-8.81 c-30.996,28.129-50.622,65.701-55.528,109.522c-3.129-4.8-6.349-10.823-8.828-17.978c-4.164-12.02-20.231-14.045-27.147-3.528 c-0.753,1.145-1.472,2.321-2.138,3.498c-29.523,52.203-39.889,111.641-28.441,163.071c3.495,15.726,10.436,30.145,20.314,42.725 c-26.629-19.684-44.429-45.851-51.377-77.11c-14.563-65.426-1.209-141.331,36.639-208.252c0.711-1.259,1.478-2.513,2.278-3.729 c1.382-2.102,4.512-1.483,5.323,0.856c11.136,32.148,31.477,49.554,32.336,50.278c4.826,4.072,12.24,0.69,12.332-5.626 c0.34-23.44,3.945-46.145,10.717-67.486c1.252-3.948-0.933-8.165-4.881-9.417c-3.948-1.255-8.165,0.932-9.417,4.88 c-5.419,17.081-8.936,34.962-10.503,53.361c-5.494-7.352-11.855-17.748-16.412-30.9c-4.897-14.135-23.839-16.634-32.028-4.189 c-0.983,1.495-1.925,3.038-2.801,4.586c-39.653,70.11-53.586,149.894-38.226,218.893c11.445,51.494,50.729,92.469,107.781,112.419 C315.81,543.946,479.734,468.861,446.905,297.961z M292.559,487.352c-21.982,17.747-64.929,10.217-71.136-17.71 c-3.279-14.728-1.049-31.584,6.095-47.231c2.991,4.715,5.991,7.336,6.469,7.738c4.822,4.066,12.24,0.699,12.332-5.626 c0.185-12.723,4.037-24.205,11.214-33.609c4.352,14.61,12.996,18.468,15.442,30.849c1.305,6.611,10.032,8.269,13.67,2.595 c1.192-1.859,2.376-3.877,3.293-6.235C306.355,437.989,314.057,469.991,292.559,487.352z M347.015,470.659 c27.968-42.47,10.323-102.416-24.355-140.257c-3.268-3.568-10.066-10.995-18.367-8.668c-5.403,1.512-8.193,6.354-9.678,10.534 c-3.291-6.478-7.928-13.59-11.708-18.305c-1.763-2.196-10.645-14.185-12.318-34.533c-0.78-9.49-12.098-13.961-19.15-7.561 c-19.658,17.838-32.767,41.259-37.366,68.511c-0.819-1.707-1.593-3.556-2.28-5.539c-3.466-10.007-16.888-11.746-22.687-2.933 c-5.662,8.601-14.488,27.569-19.319,46.702c-1.014,4.016,1.419,8.094,5.435,9.107c4.02,1.016,8.094-1.419,9.108-5.436 c3.316-13.132,8.355-25.945,14.992-38.126c6.08,14.24,15.172,22.019,15.593,22.373c4.819,4.065,12.24,0.701,12.332-5.626 c0.413-28.459,10.523-53.678,29.267-73.055c3.197,19.827,11.873,31.985,14.697,35.503c6.557,8.162,13.482,20.343,15.692,31.525 c1.303,6.601,10.026,8.281,13.669,2.595c7.212-11.24,6.683-15.578,8.098-19.89c0.722,0.644,1.678,1.583,2.933,2.953 c38.031,41.501,50.776,108.517,4.286,140.903c11.438-24.157,1.513-55.692-17.283-76.201c-2.091-2.283-6.985-7.63-13.575-5.785 c-1.684,0.471-3.145,1.328-4.379,2.566c-4.135-6.579-9.136-10.34-10.195-23.211c-0.662-8.032-10.248-11.813-16.213-6.396 c-9.374,8.519-16.298,19.273-19.959,31.779c-4.599-3.778-11.785-3.054-15.311,2.306c-12.654,19.228-19.026,53.417-9.336,75 c-23.35-15.861-30.112-38.12-29.737-66.236c0.055-4.142-3.258-7.544-7.399-7.599c-4.114-0.057-7.544,3.257-7.6,7.398 c-0.257,19.32,2.705,39.188,13.205,55.508c-19.178-14.307-32.2-33.537-37.128-55.713c-10.653-47.857-0.865-103.416,26.855-152.43 c0.502-0.887,1.045-1.775,1.639-2.695c0.001,0,0.035-0.009,0.083-0.009c0.098,0,0.256,0.037,0.333,0.26 c8.4,24.249,23.82,37.444,24.473,37.994c4.833,4.072,12.241,0.689,12.332-5.626c0.636-43.876,16.467-84.057,49.404-115.48 c3.482,32.592,17.562,52.399,21.915,57.822c10.02,12.474,20.511,30.969,23.899,48.113c1.302,6.598,10.025,8.28,13.67,2.594 c12.839-20.024,9.104-27.187,13.559-32.793c1.055,0.395,3.443,1.895,8.383,7.286c0,0,0.001,0,0.001,0.001 C393.508,320.983,413.66,419.98,347.015,470.659z" })
			)
		),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null)
	);
};

exports.default = FireWing;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/custom-icons/firewing.js
// module id = 1774
// module chunks = 895